import React from "react";
import styled from "styled-components";

const StyledMaskStyle = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  inset: 0;
    z-index: 4;
  pointer-events: auto;
  cursor:pointer;
`;

const StyledMask = ({ background, zIndex, onClick }) => {
  return <StyledMaskStyle onClick={onClick} style={{ background, zIndex }} />;
};

export default StyledMask;
